import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@dev/ee-components';
import { parse } from 'query-string';
import { useCheckoutParamsFromUrl } from '@/components/Checkouts/hooks/useRequestParams';

import { GetAllCheckoutsStart } from '@/store/checkouts/actions';
import { debounce } from '@/services/tools/debounce';


export const Search = (): JSX.Element => {
    const { t } = useTranslation();
    const queryParams = parse(location.search);
    const dispatch = useDispatch();
    const params = useCheckoutParamsFromUrl();

    const findCheckout = (ev?) => {
        const search = ev?.currentTarget?.value ?? '';
        
        debounce((): void => {
            dispatch(GetAllCheckoutsStart({ ...params, search, page: 1 }));
        }, 500);
    };

    return (
        <SearchInput
            id="mobileCheckoutsSearchInput"
            name="searchInput"
            defaultValue={queryParams.search || ''}
            onChange={findCheckout}
            onDelete={findCheckout}
            placeholder={t('searchforcheckouts')}
            type="text"
        />
    );
};
